import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import LoadingContainer from "../layouts/LoadingContainer";
import { isOnlyContsale } from "../utils/spaceModes";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import SideBar from "../layouts/SideBar";
import { useTranslation } from "react-i18next";
import { Role } from "../stores/userStore";
import { useMobile } from "../utils/mobile";
import MobileHeader from "../layouts/MobileHeader";
import MobileDrawer from "./MobileDrawer";
import addSquareImg from "../assets/img/add-square.svg";
import NewApply from "../layouts/NewApply";
import {
  BottomDrawer
} from "../components/BottomDrawer";
import { useTheme } from "styled-components";

const Bedek = ({ userStore, tenantsStore }) => {
  const [isLoading, setLoading] = useState(false);
  const [showDepratmentsMenu, setShowDepratmentsMenu] = useState(false);

  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const [title, setTitle] = useState(t("menu:bedek"));
  const theme = useTheme();
  const location = useLocation();

  const isMobile = useMobile();

  const departments = [{
    DEPARTDES: t("menu:bedek"), BEDEKFLAG: "Y"
  },
  ];

  useEffect(() => {
    const fetchSaleContracts = async () => {
      setLoading(true);
      tenantsStore.setError("");

      if (
        !tenantsStore.selectedSiteSpace?.SPACENAME &&
        userStore.userDetails.ALL_TENANT_SPACES?.length > 0
      ) {
        const first = userStore.userDetails.ALL_TENANT_SPACES[0];
        await tenantsStore.setSelectedSiteSpace(first);
        await tenantsStore.setSelectedTheme(first?.THEME);
      }

      setLoading(false);
    };
    fetchSaleContracts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedSiteSpace]);


  return (
    <div
      style={{
        height: "100vh",
      }}
    >
      <LoadingContainer isLoading={isLoading}>
        {isMobile && (
          <MobileHeader
            name={userStore.userDetails.NAME}
            title={title}
            bedek={true}
            admin={userStore.userDetails.role === Role.Admin}
          />
        )}
        {!isMobile ? (
          <SideBar
            logo={userStore.userDetails.LOGO}
            setTitle={setTitle}
            bedek={true}
            departments={departments}
          >
            <Header
              name={userStore.userDetails.NAME}
              title={title}
              bedek={true}
              admin={userStore.userDetails.role === Role.Admin}
            />
            <Outlet />
          </SideBar>
        ) : (
          <div>
            <MobileDrawer
              setTitle={setTitle}
              bedek={true}
              departments={departments?.filter((d) =>
                isOnlyContsale(tenantsStore.selectedSiteSpace)
                  ? d.BEDEKFLAG !== "Y"
                  : true
              )}
            >
              <Outlet />
              {location.pathname.includes("/bedek/applies") && <NewApply
                isMobile={true}
                backgroundColor={theme.color.green}
                style={{
                  flex: 1,
                  justifyContent: "end",
                  alignSelf: "center",
                  position: "absolute",
                  left: isRtl ? 20 : "unset",
                  right: isRtl ? "unset" : 20,
                  bottom: 30,
                  zIndex: 999,
                }}
                setTitle={setTitle}
                img={addSquareImg}
                onItemClicked={() => {
                  setShowDepratmentsMenu(!showDepratmentsMenu);
                }}
              />}
              {showDepratmentsMenu && (
                <BottomDrawer items={departments} setShow={setShowDepratmentsMenu} show={showDepratmentsMenu} bedek={true} />
              )}
            </MobileDrawer>
          </div>
        )}
      </LoadingContainer>
    </div>
  );
};

export default inject(
  "userStore",
  "tenantsStore",
  "repairPagesStore"
)(observer(Bedek));
